import { render, staticRenderFns } from "./RelationshipRepointCell.vue?vue&type=template&id=3993f7b5&scoped=true"
import script from "./RelationshipRepointCell.vue?vue&type=script&lang=js"
export * from "./RelationshipRepointCell.vue?vue&type=script&lang=js"
import style0 from "./RelationshipRepointCell.vue?vue&type=style&index=0&id=3993f7b5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3993f7b5",
  null
  
)

export default component.exports